// BR Code (Pix copia-e-cola) — EMVCo TLV builder.
// Padrão BACEN: https://www.bcb.gov.br/content/estabilidadefinanceira/forumpireunioes/AnexoI-PadroesParaIniciacaodoPix.pdf

function tlv(id: string, value: string): string {
  const len = value.length.toString().padStart(2, "0");
  return `${id}${len}${value}`;
}

// Remove acentos e caracteres não-ASCII; tudo maiúsculo.
function sanitize(s: string, max: number): string {
  return (s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Za-z0-9 ]/g, "")
    .replace(/\s+/g, " ")
    .toUpperCase()
    .trim()
    .slice(0, max)
    .trim();
}

function sanitizeTxid(s: string, max: number): string {
  const v = (s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Za-z0-9]/g, "")
    .slice(0, max);
  return v || "***";
}

function crc16(payload: string): string {
  let crc = 0xffff;
  for (let i = 0; i < payload.length; i++) {
    crc ^= payload.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) {
      crc = crc & 0x8000 ? (crc << 1) ^ 0x1021 : crc << 1;
      crc &= 0xffff;
    }
  }
  return crc.toString(16).toUpperCase().padStart(4, "0");
}

export interface BrCodeParams {
  pixKey: string;
  beneficiaryName: string;
  city: string;
  amount?: number; // BRL
  txid?: string; // até 25 chars [A-Za-z0-9], default '***'
  description?: string;
}

/**
 * Monta o BR Code Pix (estático com valor opcional).
 * Retorna string vazia se faltar dados obrigatórios.
 */
export function buildPixBrCode(p: BrCodeParams): string {
  const key = (p.pixKey || "").trim();
  if (!key) return "";

  const name = sanitize(p.beneficiaryName || "PAGADOR", 25) || "PAGADOR";
  const city = sanitize(p.city || "BRASIL", 15) || "BRASIL";
  const txid = sanitizeTxid(p.txid || "***", 25);

  // Merchant Account Information (ID 26) — Pix estático: apenas GUI + chave.
  // Bancos rejeitam sub-tag 02 (descrição) dentro do ID 26 em muitos apps.
  const merchant = tlv("00", "br.gov.bcb.pix") + tlv("01", key);

  const fields: string[] = [];
  fields.push(tlv("00", "01")); // Payload Format Indicator
  fields.push(tlv("26", merchant));
  fields.push(tlv("52", "0000")); // Merchant Category Code
  fields.push(tlv("53", "986")); // BRL
  if (p.amount && p.amount > 0) {
    fields.push(tlv("54", p.amount.toFixed(2)));
  }
  fields.push(tlv("58", "BR"));
  fields.push(tlv("59", name));
  fields.push(tlv("60", city));
  fields.push(tlv("62", tlv("05", txid)));

  const partial = fields.join("") + "6304";
  const crc = crc16(partial);
  return partial + crc;
}
